var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.148,
    height: 76.634,
    viewBox: "0 0 62.148 76.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 62.148,
    height: 76.634,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    opacity: 0.45,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M9.251,25.148v-.971c0-4.2-.008-8.393,0-12.589A11.319,11.319,0,0,1,20.861,0Q31.053,0,41.245,0A11.369,11.369,0,0,1,52.9,11.649c.009,4.167,0,8.334,0,12.5v.917c1.043.269,2.038.437,2.968.78a9.368,9.368,0,0,1,6.237,8.746c.048,10.875.065,21.751,0,32.626A9.5,9.5,0,0,1,52.671,76.6q-21.58.077-43.161,0A9.527,9.527,0,0,1,.046,67.157q-.1-16.223,0-32.448A9.522,9.522,0,0,1,8.3,25.31c.29-.045.58-.1.949-.162M31.039,70.742q10.5,0,21,0c2.707,0,4.212-1.518,4.212-4.235q0-15.56,0-31.118c0-2.834-1.475-4.31-4.316-4.31q-20.871,0-41.743,0c-2.832,0-4.3,1.481-4.3,4.325q0,15.515,0,31.03c0,2.836,1.474,4.308,4.315,4.309q10.414,0,20.827,0m15.99-45.57v-.866q0-6.294,0-12.587A5.471,5.471,0,0,0,41.21,5.882q-10.146-.013-20.292,0a5.462,5.462,0,0,0-5.793,5.771c-.009,4.225,0,8.45,0,12.675v.844Z",
    transform: "translate(0 0)",
    fill: "#00d544"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateLockIcon);
export default __webpack_public_path__ + "static/media/PrivateLockIcon.f26a8de2f7573174271f9745a5985c18.svg";
export { ForwardRef as ReactComponent };